// extracted by mini-css-extract-plugin
export default {"control":"Product_control__Ae-aq","controls":"Product_controls__-Jiti","indicator":"Product_indicator__rfoFF","indicators":"Product_indicators__DNFRE","root":"Product_root__kdGKg"};